import { createSlice } from '@reduxjs/toolkit'

const registerSlice = createSlice({
    name: 'register',
    initialState: { error: null, loading: false },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, error: payload }
        },
        register() {},
        registerSocialsError(state, payload) {
            return state
        },
    },
})

const { actions, reducer } = registerSlice

export const { setLoading, setError, register, registerSocialsError } = actions

export default reducer
